import React, { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, useParams } from 'react-router-dom';
import { getBlogPostBySlug } from './content/siteCopyHelpers';
import { useSiteSettings } from './SiteSettingsContext';
import NotFound from './NotFound';

export default function BlogPostPage() {
  const { slug } = useParams();
  const { settings: site } = useSiteSettings();
  const post = useMemo(
    () => getBlogPostBySlug(slug, site.blog_content),
    [slug, site.blog_content]
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!post) return <NotFound />;

  return (
    <div className="store-page blog-page">
      <Helmet>
        <title>{post.title} | Saloni Designs</title>
        <meta name="description" content={post.excerpt} />
      </Helmet>
      <div className="container store-page__container py-4 py-lg-5">
        <p className="small text-muted mb-3">
          <Link to="/blog">← All articles</Link>
        </p>
        <article className="blog-article">
          <header className="store-page__header mb-4">
            <h1 className="store-page__title h2 mb-3">{post.title}</h1>
            <p className="store-page__lead mb-0">{post.excerpt}</p>
          </header>
          {(post.sections || []).map((s, i) => (
            <section key={`${s.heading}-${i}`} className="blog-article__section mb-4">
              <h2 className="h5 blog-article__heading">{s.heading}</h2>
              <p className="blog-article__text">{s.body}</p>
            </section>
          ))}
          <Link to="/shop" className="btn btn-primary rounded-pill store-cta mt-2">
            Shop collections
          </Link>
        </article>
      </div>
    </div>
  );
}
